import React from "react";
import "./herosection.css";
import HeroContent from "../../hero_content";

function HeroSection() {
  return (
    <div className="bg-bg">
      <HeroContent
        title="Youth’s recreation activities and entertainment."
        para="Amet minim mollit non deserunt ullamco est sit aliqua dolor 
        do amet sint. Velit officia consequat duis enim velit mollit. 
        Exercitation veniam consequat sunt nostrud amet."
      />
    </div>
  );
}

export default HeroSection;
